import { useCallback } from 'react';
import { RenderSeriesActionFn } from '@/components/TimeSeriesTooltip/SeriesActionProvider';
import { GetSeriesById } from '@/core';
import { TimeSeriesChartProps } from '../time-series-chart-model';

/**
 * Logic to display series actions in TimeChartTooltip.
 */
export function useRenderSeriesActionFn(args: {
  getSeriesById?: GetSeriesById;
  renderSeriesActionTooltip?: TimeSeriesChartProps['renderSeriesActionTooltip'];
}) {
  const { getSeriesById, renderSeriesActionTooltip } = args;
  const renderSeriesAction: RenderSeriesActionFn = useCallback(
    (id, ctx) => {
      if (!renderSeriesActionTooltip || !getSeriesById) {
        return null;
      }
      const series = getSeriesById(id);
      if (!series) {
        return null;
      }
      return renderSeriesActionTooltip(series, ctx);
    },
    [renderSeriesActionTooltip, getSeriesById]
  );
  return renderSeriesAction;
}
